import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { OrganigrammeService } from './organigramme.service';
import { OrganigrammeEntity, OrganigrammeEntityType } from './model/entity';
import { lookupParam } from '../nav/utils';

@Injectable()
export class OrganigrammeEntityResolver implements Resolve<OrganigrammeEntity> {

  constructor(
    private router: Router,
    private organigrammeService: OrganigrammeService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): OrganigrammeEntity | Observable<OrganigrammeEntity> | Promise<OrganigrammeEntity> {
    return new Promise<OrganigrammeEntity>(async (resolve, reject) => {

      let idParam;
      let entityType: OrganigrammeEntityType;

      if(route.data.mode === 'dossier') {
        idParam = 'dossier_id';
        entityType = 'dossier';
      }
      else {
        idParam = 'record_id';
        entityType = 'record';
      }
      
      let id = lookupParam(route, idParam);

      this.organigrammeService
        .entity(entityType, id)
        .subscribe((entity) => {
          
          if(entity) {
            return resolve(entity);
          }
          else {
            this.router.navigate([entityType === 'dossier' ? 'dossiers' : 'records']);
            return resolve(null);
          }
        });
    });
  }
}